import { parseStartParamAnalytics } from '@focuslee/shared';
import { retrieveLaunchParams } from '@tma.js/sdk';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalyticsEventType } from './analyticsEvents';

type MiniAppOpenedTrackerProps = {
    recordEvent: (eventType: string, eventData?: object) => void;
};

export function MiniAppOpenedTracker({ recordEvent }: MiniAppOpenedTrackerProps) {
    const { i18n } = useTranslation();
    const fired = useRef(false);

    useEffect(() => {
        if (fired.current) return;
        fired.current = true;
        const startParam =
            retrieveLaunchParams().tgWebAppStartParam ?? new URLSearchParams(window.location.search).get('startapp');
        const parsed = parseStartParamAnalytics(startParam);
        recordEvent(AnalyticsEventType.MINI_APP_OPENED, {
            start_param: startParam ?? null,
            locale: i18n.language,
            ...parsed,
        });
    }, [i18n.language, recordEvent]);

    return null;
}
